/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

import * as Func from 'services/Function';

function BankInfo({ parent, callback }) {
  const [attr, setAttr] = useState(parent);
  const [focus, setFocus] = useState(false);

  const send = () => {
    if (attr.total * 1 < 0) {
      setAttr({ ...attr, total: '' });
    } else {
      callback(attr);
    }
  };

  return (
    <TableRow>
      <TableCell align='center'>{Func.imageDisplay(parent)}</TableCell>
      <TableCell align='left' className='nowrap'>
        {parent.name}
      </TableCell>
      <TableCell>
        <MDBox
          noValidate
          component='form'
          role='form'
          onSubmit={(e) => {
            e.preventDefault();

            send();
          }}
        >
          <MDInput
            value={attr.total === '0' ? '' : attr.total}
            type='number'
            onChange={(e) => setAttr({ ...attr, total: e.target.value })}
            onFocus={(e) => {
              setFocus(true);
              e.target.select();
            }}
            onBlur={() => {
              if (focus) {
                setFocus(false);
                send();
              }
            }}
            variant='standard'
            fullWidth
            inputProps={{
              maxLength: 20,
              autoComplete: 'off',
              className: 'text-right',
              sx: { minWidth: 80 },
            }}
          />
        </MDBox>
      </TableCell>
    </TableRow>
  );
}

BankInfo.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    total: PropTypes.string.isRequired,
  }).isRequired,
  callback: PropTypes.func.isRequired,
};

export default BankInfo;
